/* eslint-disable camelcase */
import store from '@/store'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { fbTrack } from '@/utils'
const currency = process.env.VUE_APP_CURRENCY
const content_type = 'product'

let NTDtoUSD = 27.74
// https://developers.facebook.com/docs/facebook-pixel/implementation/pixel-for-collaborative-ads

export function updateCurrencyRatio (ratio: number): void {
  NTDtoUSD = ratio
}

export function viewContent (productId: string, productName: string): void {
  window.fbq('track', 'ViewContent', {
    content_name: productName,
    content_ids: [productId],
    content_type
  })
}

export function addToCart (variantId: number, variantName: string, quantity: number): void {
  if (store.getters.isWebViewMode) {
    postAppMessage(MessageHandlers.ADD_TO_CART, { variantId, variantName })
  } else {
    fbTrack('AddToCart', {
      content_ids: [variantId],
      content_name: variantName,
      content_type
    })
  }
}

export function initiatedCheckout (amount: number): void {
  if (store.getters.isWebViewMode) {
    postAppMessage(MessageHandlers.INITIATED_CHECKOUT, { amount, currency })
  } else {
    fbTrack('InitiateCheckout', { value: amount / NTDtoUSD, currency: 'USD' })
  }
}

export function purchase (orderId: string, amount: number, contents: {id: string, quantity: number}[]): void {
  if (store.getters.isWebViewMode) {
    postAppMessage(MessageHandlers.PURCHASE, { orderId, amount, currency })
  } else {
    const umail = localStorage.getItem('userEmail')
    if (umail != null && umail !== '') {
      window.enhanced_conversion_data.email = umail
    }
    window.gtag_report_conversion(amount)
    fbTrack('Purchase', {
      order_id: orderId,
      currency: 'USD',
      value: amount / NTDtoUSD
    })
  }
}
